/**
 * Texts for home, product page, buying, themes, device picker and contact (EN = source).
 */
const pages = {
    "pages": {
        "home": {
            "eyebrow": "Garmin Connect IQ",
            "title": "Watchfaces & apps for Garmin",
            "lead": "Tactical, nautical and astronomical watchfaces with weather, tides and sky data, plus apps for air quality, weather and radiation.",
            "findTitle": "Find a watchface",
            "helpTitle": "Help with my watchface",
            "helpText": "Setup, unlocking and problems",
            "filterLabel": "Product type",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "count": "{{count}} products",
            "newBadge": "New"
        },
        "product": {
            "allDataFields": "All data field options",
            "allProducts": "All apps",
            "typeWatchface": "Watchface",
            "typeApp": "App",
            "devicesLabel": "Watches",
            "devices": "{{count}} watches",
            "rating": "Rating {{value}} of 5",
            "version": "Version",
            "goToStore": "Go to IQ Store",
            "tryVx": "Try for free (VX)",
            "tabs": {
                "overview": "Overview",
                "guides": "Guides",
                "buy": "Buy",
                "themes": "Themes"
            },
            "featuresTitle": "Features",
            "deviceNotesTitle": "Device notes",
            "guidesTitle": "Guides for {{name}}",
            "guidesIntro": "These guides apply to {{name}}.",
            "allGuides": "All guides",
            "notFound": "This product was not found.",
            "backHome": "Back to all apps"
        },
        "buy": {
            "title": "Buy & unlock",
            "chooseVersion": "Choose a version",
            "vxTab": "VX · key from this website",
            "eliteTab": "Elite · Garmin Pay",
            "step1": "Install the VX version",
            "step1Text": "Install it with the Connect IQ app and select it as your watch face. It runs as a 5-day trial.",
            "step2": "Enter your WatchfaceID",
            "step3": "Pay and enter the key",
            "step3Text": "The key is sent to the email address you enter at checkout. Enter it in the ProKey field below the WatchfaceID.",
            "spam": "Check your spam folder if the email does not arrive.",
            "paddle": "Payment via Paddle, no account needed.",
            "wfidLabel": "WatchfaceID",
            "wfidPlaceholder": "5 or 6 digits",
            "eliteText": "Buy the Elite version directly in the Connect IQ Store with Garmin Pay. It is tied to your Garmin account and needs no key.",
            "eliteNoKey": "No key is sent for Elite purchases. The watchface is unlocked right after the purchase.",
            "eliteDevices": "Garmin Pay is not available on every watch or in every country. The store page shows whether your watch is supported.",
            "eliteStore": "Buy in the Connect IQ Store",
            "standaloneText": "Install the watchface, then buy a key for your WatchfaceID here.",
            "eliteOnlyText": "This watchface is sold directly in the Connect IQ Store with Garmin Pay.",
            "guideLink": "VX or Elite? Read the guide"
        },
        "themes": {
            "noFieldLabel": "No theme field?",
            "gradientLabel": "Color gradients",
            "gradientNote": "Color gradients need a watch with a graphics processor. Older watches and some simpler models have none. There, gradients are shown in a single color or in a simplified form, and some gradient options are not offered at all.",
            "intro": "Tap [ui]Copy[/ui] and paste the theme string into the theme field in the watchface settings.",
            "guide": "How theme strings work",
            "empty": "No themes available for this watchface yet.",
            "preview": "Preview",
            "close": "Close",
            "noFieldNote": "If your settings have no theme field, theme strings are not supported for this watchface on your watch model."
        },
        "devices": {
            "myWatch": "My watch",
            "choose": "Choose your watch",
            "chooseHint": "Compatible products are highlighted on all pages. The choice is only stored in this browser.",
            "searchPlaceholder": "Search, e.g. fenix 8",
            "clear": "Remove",
            "none": "No watch found.",
            "compatible": "Runs on your {{device}}",
            "notCompatible": "Not available for your {{device}}",
            "checkTitle": "Does it run on my watch?",
            "checkPlaceholder": "Search your watch",
            "supported": "Supported",
            "notSupported": "Not supported",
            "listTitle": "All {{count}} supported watches",
            "dimmedHint": "{{count}} products do not run on your {{device}} and are dimmed.",
            "unavailable": "The device list is not available right now."
        },
        "contact": {
            "beforeEyebrow": "Before you write",
            "beforeTitle": "Often the answer is already here",
            "wfidLabel": "WatchfaceID (optional)",
            "wfidHint": "Helps with questions about keys. [link=/guides/find-watchface-id]Where to find it[/link]"
        }
    },
    "seo": {
        "contact": {
            "title": "Contact & support",
            "description": "Questions about Garmin watchfaces, unlock keys or installation? Contact TitanicTurtle support."
        },
        "newsletter": {
            "title": "Newsletter"
        },
        "notFound": {
            "title": "Page not found"
        }
    }
};
export default pages;
